<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getExpensesTypes.length > 0 && $store.getters.getExpensesTypesLoading !== true">
      <div class="custom-row pt-4">
        <div class="custom-col custom-col--20 custom-col--xs-100 custom-col--md-50 custom-col--xl-33"
             v-for="(item, index) in $store.getters.getExpensesTypes"
             :key="index"
             :item="item"
        >
          <div class="case-cart">
            <div class="case-cart__inner">

              <div class="case-cart__head">

                <div class="case-cart__label-top">
                  <div class="case-cart__label-top-i case-cart__label-top-i--letter"
                       v-bind:class="{
                        'case-cart__label-top-i--pink': item.type === EXPENSES_SYSTEM_TYPES.DEFAULT_INCOME_TYPE.value
                       }"
                  >
                    <template v-if="item.type === EXPENSES_SYSTEM_TYPES.DEFAULT_INCOME_TYPE.value">T</template>
                  </div>
                </div>

                <div class="case-cart__title case-cart__title--status">
                  <div>
                    {{item.name}}
                  </div>
                  <!--<div class="case-cart__title-sub">-->
                    <!--Type of expenses-->
                  <!--</div>-->
                </div>

                <div class="case-cart__title case-cart__title--status">
                  <div class="case-cart__title-sub">
<!--                    <TableUserNameRow-->
<!--                        v-if="item.user !== null"-->
<!--                        :item="item"-->
<!--                    />-->
                  </div>
                </div>
              </div>

              <div class="case-cart__bottom">
                <div class="case-cart__btn ml-auto">
                  <CaseCartButton
                          class="secondary-brown"
                          :value="$t('common_delete.localization_value.value')"
                          :ico="true"
                          :typeIco="'delete-brown'"
                          @click.native="deleteItem(item.id, index)"
                  >
                  </CaseCartButton>
                </div>
                <div class="case-cart__btn ml-auto">
                  <CaseCartButton
                          :value="$t('common_edit.localization_value.value')"
                          :ico="true"
                          :typeIco="'edit'"
                          @click.native="editItem(item.id)"
                  >
                  </CaseCartButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="custom-col custom-col&#45;&#45;20 custom-col&#45;&#45;xs-100 custom-col&#45;&#45;md-50 custom-col&#45;&#45;xl-33"-->
             <!--v-for="(item, index) in contain"-->
             <!--:key="index"-->
             <!--:item="item"-->
        <!--&gt;-->
          <!--<div class="case-cart">-->
            <!--<div class="case-cart__inner">-->

              <!--<div class="case-cart__head">-->

                <!--<div class="case-cart__label-top">-->
                  <!--<div class="case-cart__label-top-i case-cart__label-top-i&#45;&#45;green case-cart__label-top-i&#45;&#45;letter">-->
                    <!--P-->
                  <!--</div>-->
                <!--</div>-->

                <!--<div class="case-cart__title case-cart__title&#45;&#45;status">-->
                  <!--<div>-->
                    <!--Name of the Type-->
                  <!--</div>-->
                  <!--<div class="case-cart__title-sub">-->
                    <!--Type of expenses-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->

              <!--<div class="case-cart__bottom">-->
                <!--<div class="case-cart__btn ml-auto">-->
                  <!--<CaseCartButton-->
                          <!--class="secondary-brown"-->
                          <!--:value="'Delete'" @click.native="deleteItem"-->
                          <!--:ico="true"-->
                          <!--:typeIco="'delete-brown'"-->
                  <!--&gt;-->
                  <!--</CaseCartButton>-->
                <!--</div>-->
                <!--<div class="case-cart__btn ml-auto">-->
                  <!--<CaseCartButton-->
                          <!--:value="'Edit'"-->
                          <!--:ico="true"-->
                          <!--:typeIco="'edit'"-->
                  <!--&gt;-->
                  <!--</CaseCartButton>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="table-bottom-btn"
           v-if="$store.getters.getExpensesTypesCommonList.next_page_url !== null && $store.getters.getExpensesTypes.length > 0">
        <div class="table-bottom-btn__inner">
          <ShowMore
                  v-if="$store.getters.getExpensesTypesCommonList.next_page_url !== null && $store.getters.getExpensesTypes.length > 0"
                  @click.native="$emit('showMore')"
                  v-bind:class="{'disabled-btn' : $store.getters.getNextExpensesTypesPage}"
                  :count="$store.getters.getExpensesTypesCommonList.total - $store.getters.getExpensesTypesForPage < $store.getters.getExpensesTypesForPage ?
                $store.getters.getExpensesTypesCommonList.total - $store.getters.getExpensesTypesForPage:
                $store.getters.getExpensesTypesForPage"
          />
        </div>
      </div>
    </template>
    <template
            v-if="$store.getters.getExpensesTypes.length === 0 && $store.getters.getExpensesTypesLoading === false">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>


    <AddingExpensesProfilePopup
            v-if="isModalExpensesTypesPopup"
            :itemId="idSelectedItem"
            :type="'update'"
            :category="'income'"
            @reload="$emit('reload')"
            @close="changeExpensesTypesPopup(false)"
    />

  </div>

</template>

<script>
  import CaseCartButton from "../../../../../../../UI/buttons/CaseCartButton/CaseCartButton";
  import {EXPENSES_SYSTEM_TYPES} from "../../../../../../../../staticData/staticVariables";
  // import TableUserNameRow from "../../../../../../../coreComponents/TableComponents/TableUserNameRow/TableUserNameRow";
  import NoResult from "../../../../../../../coreComponents/NoResult/NoResult";
  import ShowMore from "../../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import AddingExpensesProfilePopup from "../../../../../popups/AddingExpensesProfilePopup/AddingExpensesProfilePopup";

  export default {
    name: "ProfilesIncomesTable",
    components: {AddingExpensesProfilePopup, ShowMore, NoResult, /*TableUserNameRow,*/ CaseCartButton},

    props: {
      contain: Array,
      countFilterParams: Number,
    },

    data() {
      return {
        EXPENSES_SYSTEM_TYPES: EXPENSES_SYSTEM_TYPES,
        isModalExpensesTypesPopup: false,
        idSelectedItem: false,
      }
    },


    methods: {

      editItem(id) {
        this.idSelectedItem = id
        this.$store.dispatch('getExpensesTypes', id).then(() => {
          this.changeExpensesTypesPopup(true)
        })
      },

      deleteItem(id, index) {
        let text = {
          title: 'common_deleteConfirm',
          txt: 'common_deleteItemAsk',
          yes: 'common_confirmDelete',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          this.$store.dispatch('deleteExpensesTypes', id).then((response) => {
            if (this._.has(response, 'data') && response.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

              let expensesTypes = this.$store.getters.getExpensesTypes
              expensesTypes.splice(index, 1)

              this.openNotify('success', 'common_notificationRecordDeleted')
            } else {
              setTimeout(() => {
                this.openNotify('error', 'common_notificationUndefinedError')
              }, 200)
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

      changeExpensesTypesPopup(val) {
        this.isModalExpensesTypesPopup = val
      },
    }

  }
</script>

<style scoped>

</style>
